import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { setLanguage } from '../actions';
import config from '../config/supported_languages.json'
import setTitlePage from './setTitlePage';


export default (Child, transFn, titlePage) => {
    class Trans extends Component {

        constructor(props) {
            super(props)
            this.state = {

            }
        }

        componentWillMount() {
            const { location, match } = this.props;
            if((this.props.lang == null || this.props.lang == "") && location.pathname == "/") {
                this.props.setLanguage(config.default_language)
            }
            this.props.setLanguage(match.params.lang);
        }

        componentWillUpdate(nextProps, nextState) {
            try {
                this.props.setLanguage(nextProps.match.params.lang);
            } catch(e) {}
        }

        render() {
            const { location, match } = this.props;
            if((this.props.lang == null || this.props.lang == "") && location.pathname == "/") {
                return <Redirect to={"/" + config.default_language} />
            }
            return setTitlePage(Child, {...this.props, trans: transFn, title: titlePage});
        }
    }

    return connect(state => {
        return {
            lang: state.app.lang
        }
    }, {
        setLanguage
    })(Trans);
};



// WEBPACK FOOTER //
// ./src/hocs/Trans.js